import React, { useState } from 'react';
import { FaWhatsapp, FaLinkedin, FaInstagram, FaBars } from 'react-icons/fa';

export default function Slider() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 3;

  const goToPrevSlide = () => {
    const newSlide = currentSlide === 0 ? totalSlides - 1 : currentSlide - 1;
    setCurrentSlide(newSlide);
  };

  const goToNextSlide = () => {
    const newSlide = currentSlide === totalSlides - 1 ? 0 : currentSlide + 1;
    setCurrentSlide(newSlide);
  };

  return (
    <div className='SliderBack' id='home'>
      <div id="carouselExampleIndicators" className="carousel slide">
        <ol className="carousel-indicators">
          <li className={currentSlide === 0 ? 'active' : ''} onClick={() => setCurrentSlide(0)}></li>
          <li className={currentSlide === 1 ? 'active' : ''} onClick={() => setCurrentSlide(1)}></li>
          <li className={currentSlide === 2 ? 'active' : ''} onClick={() => setCurrentSlide(2)}></li>
        </ol>
        <div className="carousel-inner">
          <div className={`carousel-item ${currentSlide === 0 ? 'active' : ''} ${currentSlide === 0 ? 'fade-in' : 'fade-out'}`}>
            <div className='WebSlide'>
              <div className='WebSlideItemLeft'>
                <div>
                  <h5 className='WebSlideSubHead'>Our Expertise in Web Development</h5>
                </div>
                <div>
                  <h1 className='WebSlideHead'>Web Development</h1>
                </div>
                <div>
                  <p className='WebSliderPara'>
                    Web Development is about creating and maintaining websites and online applications. It has grown a lot since the early days of the internet, now including various techniques and tools. making mobile app development a crucial skill in the modern world.
                  </p>
                </div>
                <div className='slider-buttons'>
                  <button className='contact-button'>
                    Contact Now
                  </button>
                  <button className='contact-button-1'>
                    Our Services
                  </button>
                </div>
                <div className='navbarnext-1'>
                  <a href="https://github.com/AbdullahMazher1" target="_blank" rel="noopener noreferrer">
                    <FaWhatsapp size={25} color='white' className='navbaricons inconWhatsapp' />
                  </a>
                  <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
                    <FaInstagram size={25} color='white' className='navbaricons iconInsta' />
                  </a>
                  <a href="https://www.linkedin.com/in/abdullah-mazher-a8769b289/" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin size={25} color='white' className='navbaricons iconLinkdin' />
                  </a>
                </div>
              </div>

              <div className='WebSlideItemNext'>
                <div>
                  <img className='ImWebSlide' src='webSlide.png' alt='Web Development' />
                </div>
              </div>
            </div>
          </div>
          <div className={`carousel-item ${currentSlide === 1 ? 'active' : ''} ${currentSlide === 1 ? 'fade-in' : 'fade-out'}`}>
            <div className='WebSlide'>
              <div className='WebSlideItemLeft'>
                <div>
                  <h5 className='WebSlideSubHead'>Our Expertise in Mobile Development</h5>
                </div>
                <div>
                  <h1 className='WebSlideHead'>Mobile Development</h1>
                </div>
                <div>
                  <p className='WebSliderPara'>
                    Web Development is about creating and maintaining websites and online applications. It has grown a lot since the early days of the internet, now including various techniques and tools. making mobile app development a crucial skill in the modern world.
                  </p>
                </div>
                <div className='slider-buttons'>
                  <button className='contact-button'>
                    Contact Now
                  </button>
                  <button className='contact-button-1'>
                    Our Services
                  </button>
                </div>
                <div className='navbarnext-1'>
                  <a href="https://github.com/AbdullahMazher1" target="_blank" rel="noopener noreferrer">
                    <FaWhatsapp size={25} color='white' className='navbaricons inconWhatsapp' />
                  </a>
                  <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
                    <FaInstagram size={25} color='white' className='navbaricons iconInsta' />
                  </a>
                  <a href="https://www.linkedin.com/in/abdullah-mazher-a8769b289/" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin size={25} color='white' className='navbaricons iconLinkdin' />
                  </a>
                </div>
              </div>
              <div className='WebSlideItemNext'>
                <div>
                  <img className='ImWebSlide' src='mobileSlide1.png' alt='Mobile Development' />
                </div>

              </div>
            </div>
          </div>
          <div className={`carousel-item ${currentSlide === 2 ? 'active' : ''} ${currentSlide === 2 ? 'fade-in' : 'fade-out'}`}>
            <div className='WebSlide'>
              <div className='WebSlideItemLeft'>
                <div>
                  <h5 className='WebSlideSubHead'>Our Expertise in software Development</h5>
                </div>
                <div>
                  <h1 className='WebSlideHead'>Software Development</h1>
                </div>
                <div>
                  <p className='WebSliderPara'>
                    Web Development is about creating and maintaining websites and online applications. It has grown a lot since the early days of the internet, now including various techniques and tools. making mobile app development a crucial skill in the modern world.
                  </p>
                </div>
                <div className='slider-buttons'>
                  <button className='contact-button'>
                    Contact Now
                  </button>
                  <button className='contact-button-1'>
                    Our Services
                  </button>
                </div>
                <div className='navbarnext-1'>
                  <a href="https://github.com/AbdullahMazher1" target="_blank" rel="noopener noreferrer">
                    <FaWhatsapp size={25} color='white' className='navbaricons inconWhatsapp' />
                  </a>
                  <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
                    <FaInstagram size={25} color='white' className='navbaricons iconInsta' />
                  </a>
                  <a href="https://www.linkedin.com/in/abdullah-mazher-a8769b289/" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin size={25} color='white' className='navbaricons iconLinkdin' />
                  </a>
                </div>
              </div>
              <div className='WebSlideItemNext'>
                <div>
                  <img className='ImWebSlide' src='softwareSlide1.png' alt='Data Science' />
                </div>
              </div>
            </div>
          </div>
        </div>
        <a className="carousel-control-prev y-2" href="#carouselExampleIndicators" role="button" onClick={goToPrevSlide}>
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="sr-only">Previous</span>
        </a>
        <a className="carousel-control-next y-3s" href="#carouselExampleIndicators" role="button" onClick={goToNextSlide}>
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="sr-only">Next</span>
        </a>
      </div>
    </div>
  );
}
